export default class Toastr {
  constructor() {
    document.addEventListener('DOMContentLoaded', this.initialize);
  }

  initialize() {
    // クエリパラメータにflashを入れてる場合があるのでマージしてクエリを削除
    // window.flash_jsonにflashメッセージが入っている
    const sessionFlash = JSON.parse(window.flash_json || '{}');
    const keyMap = {
      'notice': 'info',
      'alert': 'error',
      'success': 'success',
      'warning': 'warning',
    }
    const currentUrl = new URL(window.location.href)
    const searchParams = currentUrl.searchParams
    const queryFlash = {}
    for (let [key, value] of searchParams.entries()) {
      if (keyMap.hasOwnProperty(key)) {
        queryFlash[key] = value
      }
    }
    const flash = { ...queryFlash, ...sessionFlash }
    Object.entries(flash).forEach(([type, msg]) => {
      const toastrType = keyMap[type]
      if (toastrType) {
        toastr[toastrType](msg)
      }
    })
    // flashメッセージのクエリパラメータを削除
    Object.keys(keyMap).forEach((key) => {
      currentUrl.searchParams.delete(key)
    })
    if (window.history) {
      window.history.replaceState(null, null, currentUrl.href);
    }
  }
}
